/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerFindOneQueryResponse, InvitationsControllerFindOnePathParams, InvitationsControllerFindOne400, InvitationsControllerFindOne401, InvitationsControllerFindOne403, InvitationsControllerFindOne404 } from "../../models/invitationsController/InvitationsControllerFindOne";

function getInvitationsControllerFindOneUrl(id: InvitationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/invitations/${id}` as const }  
  return res
}

/**
 * @description Retrieves a specific invitation by its ID.
 * @summary Get invitation by ID
 * {@link /api/v1/invitations/:id}
 */
export async function invitationsControllerFindOne(id: InvitationsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<InvitationsControllerFindOneQueryResponse, ResponseErrorConfig<InvitationsControllerFindOne400 | InvitationsControllerFindOne401 | InvitationsControllerFindOne403 | InvitationsControllerFindOne404>, unknown>({ method : "GET", url : getInvitationsControllerFindOneUrl(id).url.toString(), ... requestConfig })  
  return res.data
}